<template>
    <div class="col-md-12" v-if="loginusercheck(174)">
        <div class="panel panel-cascade" v-if="orderconversation.status <= 4">
            <div class="panel-body" style="background-color:#d0e5cc">
                <div class="form-horizontal cascde-forms">
                    <div class="form-group row">
                        <label class="col-lg-4 col-md-3 control-label" style="color:#22690b;">
                            Conversation<span style="color: rgba(255, 0, 0, 0.67)">*</span></label>
                        <div class="col-lg-6 col-md-9">
                            <textarea class="form-control form-cascade-control input-small" v-model="detail" cols="20"
                                id="CUSTHINT" name="CUSTHINT" rows="2" style="height:83px;"></textarea>
                            <p v-if="$v.detail.$error" class="help is-danger">Conversation is Required</p>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-4 col-md-3 control-label" style="color:#22690b;">
                            Status<span style="color: rgba(255, 0, 0, 0.67)">*</span></label>
                        <div class="col-lg-6 col-md-9">
                            <select v-model="status" class="form-control form-cascade-control input-small"
                                @change="checkreject()">
                                <option value="1">Approve</option>
                                <option value="2">Reject</option>
                            </select>
                            <p v-if="$v.status.$error" class="help is-danger">Status is Required</p>
                        </div>
                    </div>
                    <div class="form-group row">
                        <label class="col-lg-4 col-md-3 control-label" style="color:#22690b;">
                            Assign To<span style="color: rgba(255, 0, 0, 0.67)">*</span></label>
                        <div class="col-lg-6 col-md-9">
                            <select v-model="followedid" class="form-control form-cascade-control input-small">
                                <option v-for="(item) in employees" v-bind:key="item.id" :value="item.id">{{ item.name
                                    }}</option>
                            </select>
                        </div>

                    </div>
                    <div class="form-group row">
                        <label class="col-lg-4 col-md-3 control-label" style="color:#22690b;">
                            Delivery Boy<span style="color: rgba(255, 0, 0, 0.67)">*</span></label>
                        <div class="col-lg-6 col-md-9">
                            <select v-model="deliveryboyid" class="form-control form-cascade-control input-small">
                                <option v-for="(item) in employees" v-bind:key="item.id" :value="item.id">{{ item.name
                                    }}</option>
                            </select>
                            <p v-if="deliveryboymissing" class="help is-danger">Delivery Boy is Required</p>
                        </div>
                    </div>
                </div>
                <div class="form-group row">
                    <div class="col-md-3"></div>
                    <div class="col-md-5 flex-around-row">
                        <button type="button" v-if="orderconversation.status == 0 && shownext == false"
                            class="btn btn-success" style="margin-top:0" @click="submit()">Submit</button>
                        <!-- <button type="button" class="btn btn-success" style="margin-top:0" @click="resolved()">Approve Order</button>
                        <button  type="button" class="btn btn-danger" style="margin-top:0" @click="resolved()">Make Pending</button>
                        <button  type="button" class="btn btn-danger" @click="disposeoff()">Delivered</button> -->
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import { validationMixin } from 'vuelidate'
import { required } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'
import Constants from '../../components/utilities/Constants.vue'
export default {
    props: ['clickedNext', 'currentStep'],
    mixins: [validationMixin, Constants],
    data() {
        return {
            status: '',
            detail: '',
            shownext: false,
            followedid: '',
            deliveryboyid: this.$store.getters.orderconversation?.deliveryboyid || '',
            deliveryboymissing: false
        }
    },
    validations: {
        status: {
            required
        },
        detail: {
            required
        },
        followedid: {
            required
        }
    },
    computed: {
        ...mapGetters([
            'loggedinuser', 'employees', 'orderconversation'
        ]),
    },
    watch: {
        $v: {
            handler: function (val) {
                if (!val.$invalid || this.orderconversation.status >= 1) {
                    this.$emit('can-continue', { value: true });
                } else {
                    this.$emit('can-continue', { value: false });
                }
            },
            deep: true
        },
        clickedNext(val) {
            console.log("clicked next:" + val)
            if (val === true) {
                this.$v.$touch();
            }
        }
    },
    mounted() {
        if (!this.$v.$invalid || this.orderconversation.status >= 1) {
            this.$emit('can-continue', { value: true });
            console.log("valid data")
        } else {
            this.$emit('can-continue', { value: false });
            console.log(" In valid data")
        }
    },
    methods: {
        submit() {
            // approving needs the delivery boy who will take the order
            this.deliveryboymissing = this.status == 1 && !this.deliveryboyid
            if (this.deliveryboymissing) return
            if (this.status != '' && this.detail != '' && this.followedid != '') {
                let param = {
                    leadid: this.orderconversation.id, detail: this.detail,
                    requesttype: 4, status: this.status, approvedbyid: this.loggedinuser?.id,
                    followedid: this.followedid
                }

                this.$http.post('api/leads/customerconversation', param)
                    .then((response) => this.processDetail(response.data))
                    .catch((err) => {
                        console.log('', err)
                    });
            }
        },
        processDetail(data) {
            // this.$parent.visitcomments = false
            this.$store.commit('assignfollowedbydispatch', data.followedid);
            let param = { id: this.orderconversation.id, column: "status", value: this.status }
            this.$http.post('api/leads/updatefield', param)
                .then((response) => this.processUpdateResponse(response.data))
                .catch((err) => {
                    console.log('', err)
                });

        },
        processUpdateResponse() {
            if (this.status == 1 && this.deliveryboyid) {
                this.$http.post('api/vsdigi/leads/orders/delivery', { id: this.orderconversation.id, deliveryboyid: this.deliveryboyid })
                    .then(() => this.$parent.parentrefresh())
                    .catch((err) => {
                        console.log('', err)
                        this.$notify({ text: 'Order approved, but the delivery boy could not be saved. Set it again in the order conversation.', type: 'error' })
                        this.$parent.parentrefresh()
                    });
                return
            }
            this.$parent.parentrefresh()
            // window.location.reload()
        },
        checkreject() {
            if (this.status == 2) {
                if (confirm("Do you want to reject this order")) {
                    alert("Order Set to Reject Successfully , Submit to Reject the order")
                }
            }
        }
    },
}
</script>